/**
 * Labstep
 *
 * @module grid/BatchCreateResourceItems/components/ColumnHeader/DateHeader/Trigger
 * @desc Batch Create Resource Items ColumnHeader
 */

import classnames from 'classnames';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import type { BatchCreateResourceItemsDateHeaderTriggerProps } from 'labstep-web/grid/BatchCreateResourceItems/components/ColumnHeader/DateHeader/Trigger/types';
import { useBatchCreateItemContext } from 'labstep-web/grid/BatchCreateResourceItems/context';
import {
  ENTITY_DATE_FORMATS,
  ENTITY_DATETIME_FORMATS,
} from 'labstep-web/grid/BatchCreateResourceItems/services/grid-batch-create-resource-items-service';
import type React from 'react';
import { useRef } from 'react';
import styles from './styles.module.scss';

export const BatchCreateResourceItemsDateHeaderTrigger: React.FC<
  BatchCreateResourceItemsDateHeaderTriggerProps
> = ({
  onClick,
  displayName,
  icon,
  cornerIcon,
  action,
  column,
  secondaryHeader,
  isDatetime,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const ctx = useBatchCreateItemContext();
  if (!ctx) {
    return null;
  }
  const { dateFormats } = ctx;

  const formats = isDatetime
    ? ENTITY_DATETIME_FORMATS
    : ENTITY_DATE_FORMATS;

  return (
    <div
      ref={ref}
      className={classnames(styles.defaultContainer)}
      data-cy={`grid/SmartTable/components/ColumnHeader/Trigger`}
      onClick={onClick}
    >
      <Flex column>
        <div className={styles.title}>
          {icon && <Icon name={icon} cornerIcon={cornerIcon} />}{' '}
          {displayName}
        </div>

        <span className={styles.secondaryHeader}>
          {dateFormats[column.getColId()] || formats[0]}
        </span>
      </Flex>

      {action}
    </div>
  );
};
